@if (label) {
<label class="block text-grey-300 font-semibold mb-2">
  {{ label }}
  <span class="text-sm text-grey-500">{{ secondaryLabel }}</span>
</label>
}

<label class="block w-full rounded-2xl border transition-all hover:border-primary/50"
  [class.border-grey-900]="!isDragging() && !error" [class.border-primary]="isDragging()"
  [class.border-green-500]="hasFile() && !error" [class.border-red-500]="error" [class.bg-blue-50]="isDragging()"
  [class.bg-green-50]="hasFile() && !error" [class.bg-red-50]="error" (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
  <input #filePicker type="file" class="hidden" [accept]="acceptAttr" [multiple]="allowMultiple"
    (input)="onSelect(filePicker.files?.item(0) ?? null, filePicker.files)" />

  <div class="flex flex-col items-center justify-center gap-2 px-6 py-5 text-center cursor-pointer relative">
    @if (hasFile() && !error) {
    <button type="button" (click)="clearFile($event)"
      class="absolute top-2 right-2 p-1 rounded-full bg-red-500 text-white hover:bg-red-600 transition-colors"
      aria-label="Remove file">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M12 4L4 12M4 4l8 8" />
      </svg>
    </button>
    }

    @if (previewUrl) {
    <img [src]="previewUrl" alt="preview" class="h-24 w-24 rounded-lg object-cover" draggable="false" />
    } @else if (isPdf) {
    <svg width="64px" height="64px" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg" fill="#000000">
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <defs>
          <style>
            .cls-1 {
              fill: #ff402f;
            }
          </style>
        </defs>
        <title></title>
        <g id="xxx-word">
          <path class="cls-1" d="M325,105H250a5,5,0,0,1-5-5V25a5,5,0,0,1,10,0V95h70a5,5,0,0,1,0,10Z"></path>
          <path class="cls-1"
            d="M325,154.83a5,5,0,0,1-5-5V102.07L247.93,30H100A20,20,0,0,0,80,50v98.17a5,5,0,0,1-10,0V50a30,30,0,0,1,30-30H250a5,5,0,0,1,3.54,1.46l75,75A5,5,0,0,1,330,100v49.83A5,5,0,0,1,325,154.83Z">
          </path>
          <path class="cls-1"
            d="M300,380H100a30,30,0,0,1-30-30V275a5,5,0,0,1,10,0v75a20,20,0,0,0,20,20H300a20,20,0,0,0,20-20V275a5,5,0,0,1,10,0v75A30,30,0,0,1,300,380Z">
          </path>
          <path class="cls-1" d="M275,280H125a5,5,0,0,1,0-10H275a5,5,0,0,1,0,10Z"></path>
          <path class="cls-1" d="M200,330H125a5,5,0,0,1,0-10h75a5,5,0,0,1,0,10Z"></path>
          <path class="cls-1"
            d="M325,280H75a30,30,0,0,1-30-30V173.17a30,30,0,0,1,30-30h.2l250,1.66a30.09,30.09,0,0,1,29.81,30V250A30,30,0,0,1,325,280ZM75,153.17a20,20,0,0,0-20,20V250a20,20,0,0,0,20,20H325a20,20,0,0,0,20-20V174.83a20.06,20.06,0,0,0-19.88-20l-250-1.66Z">
          </path>
          <path class="cls-1"
            d="M145,236h-9.61V182.68h21.84q9.34,0,13.85,4.71a16.37,16.37,0,0,1-.37,22.95,17.49,17.49,0,0,1-12.38,4.53H145Zm0-29.37h11.37q4.45,0,6.8-2.19a7.58,7.58,0,0,0,2.34-5.82,8,8,0,0,0-2.17-5.62q-2.17-2.34-7.83-2.34H145Z">
          </path>
          <path class="cls-1"
            d="M183,236V182.68H202.7q10.9,0,17.5,7.71t6.6,19q0,11.33-6.8,18.95T200.55,236Zm9.88-7.85h8a14.36,14.36,0,0,0,10.94-4.84q4.49-4.84,4.49-14.41a21.91,21.91,0,0,0-3.93-13.22,12.22,12.22,0,0,0-10.37-5.41h-9.14Z">
          </path>
          <path class="cls-1" d="M245.59,236H235.7V182.68h33.71v8.24H245.59v14.57h18.75v8H245.59Z"></path>
        </g>
      </g>
    </svg>
    } @else if (error) {
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
      <circle cx="24" cy="24" r="20" fill="#FEE2E2" />
      <path d="M24 16v8M24 28h.01" stroke="#DC2626" stroke-width="2" stroke-linecap="round" />
    </svg>
    } @else {
    <svg width="28" height="32" viewBox="0 0 28 32" aria-hidden="true">
      <g clip-path="url(#clip0)">
        <rect width="25.3866" height="29.6177" rx="2" fill="#F3F5FB" />
        <path
          d="M26.3062 4.25621C26.8276 4.82933 26.5273 5.75214 25.7684 5.90859L19.1252 7.27815C18.4386 7.41972 17.8232 6.82907 17.9365 6.13718L19.1396 -1.21155C19.2748 -2.037 20.3032 -2.34164 20.8661 -1.72296L26.3062 4.25621Z"
          fill="#BCC7EC" />
        <rect width="7.59173" height="17.228" transform="translate(16.1719 -2.79297) rotate(-45)" fill="white" />
        <rect x="5" y="12" width="16" height="1" rx="0.5" fill="#253A81" />
        <rect x="5" y="15" width="16" height="1" rx="0.5" fill="#253A81" />
        <rect x="5" y="18" width="16" height="1" rx="0.5" fill="#253A81" />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="25.3866" height="29.6177" rx="2" />
        </clipPath>
      </defs>
    </svg>
    }

    <div class="text-lg font-semibold" [class.text-primary]="!error && !hasFile()" [class.text-green-600]="hasFile()"
      [class.text-red-600]="error">
      @if (isDragging()) {
      Drop {{ allowMultiple ? 'files' : 'file' }} here
      } @else if (hasFile() && !error) {
      ✓ {{ allowMultiple && files.length > 1 ? files.length + ' files' : 'File' }} uploaded
      } @else if (error) {
      Upload failed
      } @else {
      {{ title }}
      }
    </div>

    <p class="text-sm text-grey-400">
      {{supportedText}}
    </p>
    <p class="text-sm text-grey-400">
      Maximum Size: {{ (maxSizeBytes / 1024 / 1024) | number : '1.0-0' }}MB
    </p>

    @if (allowMultiple && (files.length > 0 || urlList.length > 0)) {
    <div class="w-full space-y-2">
      @for (url of urlList; track url; let i = $index) {
      <div class="flex items-center justify-between p-2 bg-white rounded border border-grey-200">
        <div class="flex-1 min-w-0">
          <p class="text-xs font-medium text-grey-700 truncate">{{ url.split('/').pop() }}</p>
          <a [href]="url" target="_blank" class="text-xs text-primary hover:underline">View</a>
        </div>
      </div>
      }
      @for (file of files; track file.name; let i = $index) {
      <div class="flex items-center justify-between p-2 bg-white rounded border border-grey-200">
        <div class="flex-1 min-w-0">
          <p class="text-xs font-medium text-grey-700 truncate">{{ file.name }}</p>
          <p class="text-xs text-grey-500">{{ (file.size / 1024) | number : '1.0-0' }} KB</p>
        </div>
        <!-- <button type="button" (click)="clearFile($event, i)"
          class="ml-2 p-1 rounded-full bg-red-500 text-white hover:bg-red-600 transition-colors flex-shrink-0"
          aria-label="Remove file">
          <svg width="12" height="12" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 4L4 12M4 4l8 8" />
          </svg>
        </button> -->
      </div>
      }
    </div>
    } @else if (fileName) {
    <p class="text-xs text-grey-700 break-all font-medium">{{ fileName }}</p>
    <p class="text-xs text-grey-500">{{ (fileSize / 1024) | number : '1.0-0' }} KB</p>
    }

    @if (error) {
    <div class="text-sm text-red-600 font-medium flex items-center gap-1">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
        <circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" stroke-width="1.5" />
        <path d="M8 4v4M8 10h.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
      </svg>
      {{ error }}
    </div>
    }
  </div>
</label>